import {
    startOfDay,
    addDays,
    isValidDate,
    isSameDate,
    subtractDays,
} from '@superbet-group/web.lib.utilities';

import { ExpandedEventInUrl } from '@app/enums';
import { IState } from '@app/store';
import parseDateUrl from '@core/utils/url/parseDateUrl';

import sportModule from './sport';
import { TimeFilterSlug } from '../shared/timeFilter/utils';

const storePath = 'ui/results';

let today = new Date();

interface UIResultsState {
    isLeftSidebarOpen: boolean;
}

export default {
    namespaced: true,
    state: {
        isLeftSidebarOpen: false,
    } as UIResultsState,
    modules: {
        sport: sportModule(storePath),
    },
    getters: {
        expandedEventId: (state: Record<string, unknown>, getters: any, rootState: IState, rootGetters: any) => {
            // eslint-disable-next-line sonarjs/no-duplicate-string
            const eventId = rootGetters['navigation/route'].query[ExpandedEventInUrl.event];
            return eventId ? parseInt(eventId, 10) : null;
        },
        selectedDate(state: any, getters: any, rootState: IState, rootGetters: any) {
            try {
                // First part is backwards compat, second part gets the results date in the offer grid!
                const dateParam = rootGetters['navigation/route'].params.date ?? rootGetters['navigation/route'].params.timeFilter;
                const date = parseDateUrl(dateParam);

                if (!isValidDate(date)) {
                    throw date;
                }
                return date;
            } catch (e) {
                if (!isSameDate(today, new Date())) {
                    today = new Date();
                }
                // constant to avoid triggering watchers
                return today;
            }
        },
        timeWindow(state: any, getters: any, rootState: IState, rootGetters: any) {
            const dateParam = rootGetters['navigation/route'].params.timeFilter;
            if (dateParam === TimeFilterSlug.All) {
                const now = new Date();
                return [
                    subtractDays(7, now),
                    now,
                ];
            }
            const startDate = startOfDay(getters.selectedDate);
            const endDate = startOfDay(addDays(1, getters.selectedDate));
            return [startDate, endDate];
        },
    },
};
